import { AfterViewInit, Component, ElementRef, Input, NgZone, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-embedded-podcast',
  templateUrl: './embedded-podcast.component.html',
  styleUrls: ['./embedded-podcast.component.css']
})
export class EmbeddedPodcastComponent implements AfterViewInit, OnChanges {
  @ViewChild('spotifyContainer', { static: true }) spotifyContainer!: ElementRef;
  @Input() spotifyId = 'SPOTIFY_ID';
  private safeUrl: SafeResourceUrl;
  private iframe!: HTMLIFrameElement;

  constructor(private sanitizer: DomSanitizer, private ngZone: NgZone) {}

  ngAfterViewInit(): void {
    this.getSpotifyLink();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['spotifyId']) {
      this.getSpotifyLink();
    }
  }

  getSpotifyLink(): void {
    this.ngZone.runOutsideAngular(() => {
      if (this.iframe) {
        this.spotifyContainer.nativeElement.removeChild(this.iframe);
        this.iframe = undefined as any; // Clear reference
      }
      this.iframe = document.createElement('iframe');

      let isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || (navigator.userAgent.includes("Macintosh") && navigator.maxTouchPoints > 1);
      if (isMobile) {
        this.iframe.width = '320';
        this.iframe.height = '157';
      } else {
        this.iframe.width = '500';
        this.iframe.height = '236';
      } 

      this.iframe.src = `https://open.spotify.com/embed/episode/${this.spotifyId}?utm_source=generator`;
      // this.iframe.allow = 'accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      // this.iframe.allowFullscreen = false;

      this.spotifyContainer.nativeElement.appendChild(this.iframe);
    });
  }

  getSafeUrl(spotifyId: string): SafeResourceUrl {
    if (!this.safeUrl) {
      this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        `https://open.spotify.com/embed/episode/${spotifyId}?utm_source=generator`
      );
    }
    return this.safeUrl;
  }

}
